const API_NAMES = JSON.parse(process.env.REACT_APP_API_NAME);

export const PRESCRIPTSURE = {
  DRUGSAPI: API_NAMES.drugs_api_name,
  MEDICARE_API: API_NAMES.medicare_api_name,
  COMMERCIAL_API: API_NAMES.commercial_api_name,
  MMIT_COVERAGE_API: API_NAMES.mmit_coverage_api_name, // New unified coverage API
  STRIPE_API: API_NAMES.shared_api_name,
  USER_API: API_NAMES.user_api_name,
  SA_USER_API: API_NAMES.sa_user_api_name,
  FAQ_API: API_NAMES.shared_api_name,
  SUPPORT_FEEDBACK_API: API_NAMES.shared_api_name,
  ANALYTICS_API: API_NAMES.analytics_api_name,
};
